const adjectives = [
    ['kurz', [], ['short', 'brief']],
    ['lang', [], ['long']],
    ['hoch', [], ['high', 'tall']],

    ['groß', [], ['big', 'great', 'large']],
    ['klein', [], ['small', 'little']],

    ['dunkel', [], ['dark']],
    ['hell', [], ['bright', 'clear']],

    ['langsam', [], ['slow']],
    ['schnell', [], ['fast']],

    ['gut', [],     ['good']],
    ['schlimm', [], ['bad']],

    ['stark', [],   ['strong', 'intense']],
    ['schwach', [], ['weak', 'faint']],

    ['kühl', [], ['cool', 'frigid']],
    ['warm', [], ['hot', 'cordial']],
    ['kalt', [], ['cold', 'frigid']],

    ['teuer', [],   ['expensive']],
    ['billig', [],  ['cheap', 'low-cost']],
    ['sparsam', [], ['thrifty', 'frugal']],

    ['jung', [],    ['young', 'youthful']],
    ['alt', [],     ['old', 'aged']],

    ['dumm', [],    ['stupid']],
    ['klug', [],    ['clever', 'knowledgeable']],

    ['dick', [],    ['thick', 'fat']],
    ['schlank', [],     ['slim', 'slender']],

    ['männlichen', [],  ['masculine']],
    ['feminin', [],     ['feminine']],

    ['schmutzig', [],   ['dirty', 'filthy']],
    ['sauber', [],      ['clean', 'neat']],

    ['sicher', [],      ['sure', 'certain']],
    ['unsicher', [],    ['unsure', 'uncertain']],

    ['modisch', [],     ['fashionable']],
    ['unmodisch', [],   ['unfashionable']],

    ['beliebt', [],     ['popular', 'favored']],
    ['unbeliebt', [],   ['unpopular', 'out-of-favor']],

    ['weit', [],        ['far', 'wide', 'vast']],
    ['gedulgig', [],    ['patient', 'uncomplaining']],
    ['ungedulgig', [],  ['impatient']],
    ['arm', [],         ['poor', 'low-grade']],

    ['wütend', [],  ['angry', 'mad']],
    ['traurig', [], ['sad', 'unhappy']],
    ['nervös', [],  ['nervous']],

    ['kräftig', [], ['strong', 'robust']],
    ['stabil', [],  ['stable']],

    ['interessant', [],     ['interesting']],
    ['uninteressant', [],   ['dull', 'bland']],
    ['hart', [],    ['hard', 'tough', 'stiff']],

    ['gesund', [],  ['healthy', 'fit']],
    ['ungesund', [],    ['unhygienic', 'not healthy']],

    ['sortiert', [],      ['sorted', 'assorted']],
    ['organisiert', [],   ['organized']],
    ['unorganisiert', [], ['unorganized']],

    ['komisch', [],     ['funny', 'comical']],
    ['sympathisch', [], ['likeable', 'personable']],
    ['freundlich', [],  ['friendly', 'amiable']],
    ['unfreundlich', [],['unfriendly', 'unkind']],

    // Farben
    ['rot', [],         ['red']],
    ['dunkelrot', [],   ['dark red']],
    ['schwarz', [],     ['black']],
    ['grau', [],        ['grey']],
    ['dunkelgrau', [],  ['dark grey']],
    ['violett', [],     ['purple']],
    ['blau', [],        ['blue']],
    ['violett', [],     ['purple']],
    ['gelb', [],        ['yellow']],
    ['orange', [],      ['orange']],
    ['grün', [],        ['green']],
    ['hellgrün', [],    ['light green', 'lime green']],
    ['weiß', [],        ['white']],
    ['türkis', [],      ['turquoise']],
    ['rosa', [],        ['pink']],
    ['braun', [],       ['brown']],
    ['hellbraun', [],   ['beige', 'light brown']],
    ['opak', [],        ['opaque']],
    ['durchsichtig', [],['transparent', 'see-through']],

    // "Mein Körper weiß alles"
    ['gegenwärtig', [], ['current', 'present']],
    ['vollkommen', [],  ['ideal', 'perfect']],
    ['fest', [],        ['firm', 'solid']],
    ['eingefroren', [], ['frozen']]
];

export default adjectives;


/** WEBPACK FOOTER **
 ** ./tables/adjectives/roots/adjectives.js
 **/